import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../../../../cra/src/styling/breakpointsMinWidth';

import { Search } from '../../../../../icons';

const SearchWrap = styled.div`
  position: relative;

  margin: 0 0 16px 0;

  svg {
    margin: auto;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 16px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    grid-row: 1;
    grid-column: 4 / span 3;

    margin: 0;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 7 / span 4;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    grid-column: 8 / span 3;
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 7 / span 2;
  }
`;

const Input = styled.input`
  width: 100%;
  background: #f1f1f1;

  border: none;
  border-radius: 4px;

  text-indent: 48px;

  height: 48px;

  padding-right: 10px;
`;

const SearchBar = ({ setSearchedValue }) => (
  <SearchWrap>
    <Search fill="#828282" width="24" height="24" />
    <Input
      type="search"
      placeholder="Search articles here..."
      onChange={(e) => setSearchedValue(e.target.value)}
    />
  </SearchWrap>
);

export default SearchBar;
